/** Dashboard API service. */

import { apiClient } from '../client';
import { API_ENDPOINTS } from '../endpoints';
import type { HypeScoreWindow } from '@/stores/dashboard';
import type { DashboardHypeScorePayload, DashboardResponse } from '@/types/responses';
import { withDedupe } from '@/utils/requestDedupe';

let dashboardEtag: string | undefined;

/** Clear stored ETag (e.g. after logout); next fetch will be unconditional. */
export function resetDashboardEtag(): void {
  dashboardEtag = undefined;
}

/**
 * Fetch dashboard JSON. Returns null when server responds 304 Not Modified (body unchanged).
 */
export async function fetchDashboardHypeScores(window: HypeScoreWindow): Promise<DashboardHypeScorePayload> {
  return withDedupe(`dashboard:hype:${window}`, async () => {
    const url = `${API_ENDPOINTS.dashboardHypeScore}?window=${encodeURIComponent(window)}`;
    const { data } = await apiClient.get<DashboardHypeScorePayload>(url);
    return data;
  });
}

export async function fetchDashboardData(): Promise<DashboardResponse | null> {
  return withDedupe('dashboard:v1:fetch', async () => {
    try {
      const r = await apiClient.getWithETag<DashboardResponse>(API_ENDPOINTS.dashboard, dashboardEtag);
      if (r.notModified) {
        return null;
      }
      if (r.etag) {
        dashboardEtag = r.etag;
      }
      return r.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  });
}

